<template>
    <header :class="classname" :id="idname">
        <!-- Loading -->
        <loading />

        <div class="module-action-header-content">
            <div class="title-and-action-wrapper">
                <div class="title-wrapper">
                    <h1 class="heading-4">
                        {{ dynamicStyleModuleName(modulename) }}
                    </h1>
                    <h2 v-if="subheaderstring" class="body-1 color-text-body">
                        {{ subheaderstring }}
                    </h2>
                </div>

                <div class="action-wrapper">
                    <div
                        v-if="createlink && !conditionalformobileindicate"
                        class="btnlinkbase"
                    >
                        <a
                            :href="createlink"
                            class="btn btn-primary btnlink"
                            target="_self"
                            aria-describedby="Add new item"
                            ><p class="buttom-body color-white">
                                Criar {{ dynamicStyleModuleName(modulename) }}
                            </p></a
                        >
                    </div>
                    <div v-else class="btnlinkbase">
                        <a
                            :data-mobileindicate="mobileindicatename"
                            class="btn btn-primary btnlink"
                            target="_self"
                            aria-describedby="Add new item"
                            ><p class="buttom-body color-white">
                                Criar {{ dynamicStyleModuleName(modulename) }}
                            </p></a
                        >
                    </div>

                    <!-- 
                    <div v-if="extralink" class="btnlinkbase">
                        <a
                            :href="extralink"
                            class="btn btn-secondary btnlink"
                            target="_self"
                            aria-describedby="List Data"
                            >Manual Reviews</a
                        >
                    </div>
                     -->
                </div>
            </div>

            <div class="module_actions" id="module_actions">
                <div class="input-group">
                    <button
                        @click="searchValue()"
                        class="btn"
                        type="button"
                        id="search-module"
                    >
                        <span></span>
                    </button>

                    <input
                        type="text"
                        class="form-control"
                        v-model="searchInput"
                        :placeholder="searchplaceholder"
                        aria-label="Inform parameters to search"
                        aria-describedby="search-module"
                        @keydown.delete="cleanSearchInput($event)"
                        @keyup.delete="cleanSearchInput($event)"
                        @keydown.enter="searchValue()"
                    />
                </div>

                <div class="order-select">
                    <span></span>

                    <select
                        v-model="orderby"
                        class="form-select button-body"
                        aria-label="Order Data"
                        @change="setOrderMethod(indicateordermethod)"
                    >
                        <option selected>Order</option>
                        <option value="asc">ASC</option>
                        <option value="desc">DESC</option>
                    </select>

                    <div class="">
                        <slot name="custom_action"></slot>
                    </div>
                </div>
            </div>

            <div v-if="idname === 'user_header'" class="module_buttons">
                <div class="module_buttons_actions">
                    <button
                        class="btn buttonlist button-body strong-500"
                        data-action="professional"
                        type="button"
                        @click="buttonActions($event)"
                    >
                        Profissional
                    </button>

                    <button
                        class="btn buttonlist button-body strong-500"
                        data-action="admin"
                        type="button"
                        @click="buttonActions($event)"
                    >
                        Administrador
                    </button>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import fetchData from "./../../fetchData.js";
import Loading from "./LoadingElement.vue";
import inputValidation from "./../../validationInputs.js";
import defaultWebsite from "../../defaultWebsiteScript.js";

export default {
    name: "ModuleActionElement",
    emits: ["dynamic-data", "user-data"],
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        alldata: {
            type: String,
            required: true,
        },
        orderurl: {
            type: String,
            required: true,
        },
        searchurl: {
            type: String,
            required: true,
        },
        classname: {
            type: String,
            required: true,
        },
        idname: {
            type: String,
            required: true,
        },
        modulename: {
            type: String,
            required: true,
        },
        searchplaceholder: {
            type: String,
            required: true,
        },
        createlink: {
            type: String,
            required: false,
        },
        ordermethodarray: {
            type: String,
            required: false,
        },
        newdata: {
            type: Array,
            required: false,
        },
        extralink: {
            type: String,
            required: false,
        },
        subheaderstring: {
            type: String,
            required: false,
        },
        mobileindicatename: {
            type: String,
            required: true,
        },
        btnheaderactions: {
            type: Function,
            required: false,
        },
        conditionalaction: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            orderby: "Order",
            searchInput: "",
            searchData: {},
            dynamicData: {},
            orderData: {},
            validationSearchtype: "",
            searchDataType: "",
            moduleData: {},
            currentYear: "",
            indicateordermethod: false,
            newData: [],
            limitwidth: 1180,
            conditionalformobileindicate: false,
        };
    },
    created() {
        //Set Module Data
        this.moduleData = JSON.parse(this.alldata);

        //Set Current Year
        let dateData = new Date();

        //Set year
        this.currentYear = dateData.getFullYear();
    },
    mounted() {
        //Set New Data
        if (this.newdata) {
            this.newData = this.newdata;
        }

        //Set Module Data
        this.moduleData = JSON.parse(this.alldata);

        //Indicate order method
        this.indicateordermethod = this.ordermethodarray ? true : false;

        //Get Width
        let screenWidth = window.screen.width;

        //Set Conditional for show Mobile Indicate
        this.conditionalformobileindicate = screenWidth <= this.limitwidth;

        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(screenWidth);
        });
    },
    methods: {
        orderValue() {
            //List of Order Values
            let listOfOrderValues = ["asc", "desc"];

            //Only Send Order Values
            if (!listOfOrderValues.includes(this.orderby)) {
                return;
            }

            //Clean Data
            this.orderData = {};
            this.dynamicData = {};

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //DataForm
            let dataForm = {
                orderby: this.orderby
            };

            if(this.conditionalaction){

                dataForm.ordercond = this.conditionalaction;

            }

            //Get Data from Url
            let response = fetchData.structureTosendData(
                this.orderurl,
                dataForm,
                this.csrftolken,
                "POST"
            );

            //Resolve Promise
            response
                .then((value) => {
                    //Set Search Review attData
                    if (value.hasOwnProperty("attData")) {
                        //Desactive Loading
                        document
                            .querySelector(".loadingbase")
                            .classList.remove("d-flex");

                        //Set Data
                        this.orderData = JSON.parse(value.attData);

                        //Set Dynamic Data
                        this.dynamicData = this.orderData;

                        //Set Default Value for orderBy
                        this.orderby = "Order";

                        //Set Defaul Module Data
                        return this.$emit("dynamic-data", this.dynamicData);
                    }
                })
                .catch((error) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Set Defaul Module Data
                    this.$emit("dynamic-data", this.dynamicData);

                    //Set Error Message
                    throw new Error(error);
                });
        },
        orderValueArray() {
            //List of Order Values
            let listOfOrderValues = ["asc", "desc"];

            //Only Send Order Values
            if (!listOfOrderValues.includes(this.orderby)) {
                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Set Dynamic Data
            this.dynamicData = this.moduleData;

            switch (this.orderby) {
                case "asc":
                    this.dynamicData = Object.values(this.dynamicData).sort();
                    break;

                case "desc":
                    this.dynamicData = Object.values(
                        this.dynamicData
                    ).reverse();
                    break;
            }

            //Desactive Loading
            document.querySelector(".loadingbase").classList.remove("d-flex");

            //Set Default Value for orderBy
            this.orderby = "Order";

            return this.$emit("dynamic-data", this.dynamicData);
        },
        setOrderMethod(ordermethodarray) {
            if (ordermethodarray) {
                return this.orderValueArray();
            }

            return this.orderValue();
        },
        cleanSearchInput(element) {
            //Check Empty Value from InputSearch
            if (
                this.searchInput === "" &&
                Object.values(this.searchData).length > 0
            ) {
                //Clean Data
                this.searchData = {};

                //Check per new data
                if (this.newData) {
                    this.moduleData =
                        JSON.stringify(this.newData).length >
                        JSON.stringify(this.moduleData)
                            ? this.newData
                            : this.moduleData;
                }

                //Set Defaul Module Data
                return this.$emit("dynamic-data", this.moduleData);
            }

            //Set Defaul Module Data
            return this.$emit("dynamic-data", {});
        },
        getSearchDataTypeCase(data, conditional, validationcase) {
            //Data Type Conditional
            if (data.includes(conditional)) {
                //Set dynamic input validation case
                this.validationSearchtype = validationcase;
            }
        },
        errorSearchMessage(message) {
            //Clean Variable
            this.searchInput = "";

            //Show Error Message
            alert(message);

            //Desactive Loading
            document.querySelector(".loadingbase").classList.remove("d-flex");

            return;
        },
        getSearchDataType(casetype) {
            switch (casetype) {
                //String
                case 1:
                    this.searchDataType = "string";

                    break;

                //Number
                case 2:
                    this.searchDataType = "number";

                    break;

                //Email
                case 7:
                    this.searchDataType = "email";

                    break;

                //Date
                case 9:
                    this.searchDataType = "date";

                    break;
            }
        },
        searchValue() {
            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Clean Data
            this.searchData = {};
            this.dynamicData = {};

            //Get InputValidation Case
            this.getSearchDataTypeCase(this.searchInput.trim(), "@", 7);

            //Second check for input validation case
            if (this.validationSearchtype === "") {
                this.getSearchDataTypeCase(this.searchInput.trim(), "/", 9);
                this.getSearchDataTypeCase(this.searchInput.trim(), "-", 9);
            }

            //Check by number
            if (
                Number.isInteger(parseInt(this.searchInput.trim())) &&
                this.validationSearchtype === ""
            ) {
                //Only Numbers
                this.validationSearchtype = 2;
            }

            //Check String
            if (
                !Number.isInteger(parseInt(this.searchInput.trim())) &&
                !this.searchInput.trim().includes("@") &&
                !this.searchInput.trim().includes("/") &&
                this.validationSearchtype === ""
            ) {
                //Only Letters, special chars and white space
                this.validationSearchtype = 1;
            }

            //Validate Url
            let checkSearchData = inputValidation.validNameCases(
                this.validationSearchtype,
                this.searchInput.trim()
            );

            //Check Url
            if (!checkSearchData) {
                //Error Message
                this.errorSearchMessage(
                    "Please insert a valid input to search"
                );

                return;
            }

            //Set Search Data Type
            this.getSearchDataType(this.validationSearchtype);

            //Clean ValidationSearch type
            this.validationSearchtype = "";

            //DataForm
            let dataForm = {
                searchdata: this.searchInput.trim(),
                searchtype: this.searchDataType,
            };

            if(this.conditionalaction){

                dataForm.searchcond = this.conditionalaction;

            }

            //Get Data from Url
            let response = fetchData.structureTosendData(
                this.searchurl,
                dataForm,
                this.csrftolken,
                "POST"
            );

            //Resolve Promise
            response
                .then((value) => {
                    //Set Search Review attData
                    if (value.hasOwnProperty("attData")) {
                        //Desactive Loading
                        document
                            .querySelector(".loadingbase")
                            .classList.remove("d-flex");

                        //Clean Variable
                        //this.searchInput = '';
                        this.searchDataType = "";

                        //Message Error
                        if (Object.values(value.attData).length === 0) {
                            //Show Message
                            alert(value.message);

                            return;
                        }

                        //Set Data
                        this.searchData = JSON.parse(value.attData);

                        //Set Dynamic Data
                        this.dynamicData = this.searchData;

                        //Set Defaul Module Data
                        return this.$emit("dynamic-data", this.dynamicData);
                    }
                })
                .catch((error) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Clean Variable
                    //this.searchInput = '';
                    this.searchDataType = "";

                    //Set Defaul Module Data
                    this.$emit("dynamic-data", this.dynamicData);

                    //Set Error Message
                    throw new Error(error);
                });
        },
        dynamicStyleModuleName(modulename) {
            return defaultWebsite.dynamicStyleModuleName(modulename);
        },
        buttonActions(element = null) {
            this.$emit("user-data", this.btnheaderactions(element));
        },
    },
    computed: {
        computedSearchData() {
            return this.searchData;
        },
        computedDynamicData() {
            return this.dynamicData;
        },
        computedOrderData() {
            return this.orderData;
        },
        computedSearchInputValidationType() {
            return this.validationSearchtype;
        },
        computedGetSearchDataType() {
            return this.searchDataType;
        },
        computedNewData() {
            return this.newData;
        },
    },
    watch: {
        computedSearchData() {},
        computedDynamicData() {},
        computedOrderData() {},
        computedSearchInputValidationType() {},
        computedGetSearchDataType() {},
        computedNewData() {},
    },
    components: {
        loading: Loading,
    },
};
</script>
